(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('Icd10DialogController', Icd10DialogController);

    Icd10DialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Icd10'];

    function Icd10DialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Icd10) {
        var vm = this;
        vm.icd10 = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:icd10Update', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.icd10.id !== null) {
                Icd10.update(vm.icd10, onSaveSuccess, onSaveError);
            } else {
                Icd10.save(vm.icd10, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
